import React, { useEffect } from 'react';
import { InstructionsList } from 'components/newIdentifyMethods/video/components/InstructionsList';
import { formatText, getLanguage } from 'core/i18n';
import FullForm from '../../Layouts/FullForm';
import { SafeDataAdvise } from 'components/newIdentifyMethods/video/components/SafeDataAdvise';
import VideoClause from 'components/newIdentifyMethods/video/VideoClause/VideoClause';
import DocumentationRequiredHeader from 'components/documentationRequiredHeader/DocumentationRequiredHeader';
import { VIDEO_SELFIE } from 'constants/identityMethod';
import './videoselfie.scss';
import {
    getCurrentDate,
    checkVideoPermission,
    getPermissionMessage,
} from 'components/newAccountSteps/profileSteps/profileStep3/videocall/videocallHelper';
import { START } from 'constants/video/status';
import { Header } from 'components/header/header';
import { recordEventCustomOnly, recordPage } from 'utilities/uTagging';
import ImportantMessageBox from 'components/messagesScreen/ImportantMessageBox';
import { COMPLETED } from 'constants/statusProcess';
import { SuccessView } from './SuccessView';
import PropTypes from 'prop-types';
import { VideoScreenContainer } from 'components/newIdentifyMethods/VideoScreen/VideoScreenContainer';
import { ORIGIN_BY_CHANNEL } from 'constants/uTagConstants/origin';

const VIDEO_SELFIE_URL = 'clientIdentificationUnassistedVideoCall';
export const VideoSelfie = ({
    identifyVideo,
    options,
    userProfile,
    showModalCancel,
    setValidity,
    change,
    showPreLoader,
    loanStatus,
    loanIdentification,
    hidePreLoader,
}) => {
    useEffect(() => {
        recordPage(
            '/onboarding/identidad/',
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            'ares',
            {
                tipoPagina: 'generica',
                tipoProceso: 'onboarding',
                pasoProceso: 'identidad',
                tipoOnboarding: 'ares',
                productoOnboardingDetalle: 'prestamo ares',
                onboardingDocType: 'tipo de documento',
                onboardingOrigin: ORIGIN_BY_CHANNEL[userProfile.channel],
            }
        );
    }, []);

    const isVideoContinueDisabled = () => {
        const { agreeVideoCallClauseCheck, grantedPermission } = userProfile;

        return !agreeVideoCallClauseCheck || !grantedPermission;
    };

    const handleContinue = () => {
        if (isVideoContinueDisabled()) {
            !userProfile.agreeVideoCallClauseCheck &&
                setValidity('userProfile.agreeVideoCallClauseCheck', { required: false });

            return;
        }

        recordEventCustomOnly({
            categoriaEvento: 'interaccion en identidad',
            accionEvento: 'continuar',
            event_name: 'event_success',
            action: 'success',
            format: 'steps',
            component: 'funnel',
            element: 'identity',
        });

        const date = getCurrentDate(options);
        const language = getLanguage();

        identifyVideo({ date, videoCallType: VIDEO_SELFIE, urlCallType: VIDEO_SELFIE_URL, language });
    };

    const handleCancel = () => {
        showModalCancel();
        recordEventCustomOnly({
            accionEvento: 'salir',
            categoriaEvento: 'interaccion en tu actividad',
        });
    };

    const handleVideoClauseChange = checkBoxValue => {
        checkVideoPermission({
            grantedPermission: userProfile.grantedPermission,
            changeFunction: change,
            videoSelected: VIDEO_SELFIE,
        });

        recordEventCustomOnly({
            categoriaEvento: 'interaccion en identidad',
            accionEvento: 'acepto terminos y condiciones',
            etiquetaEvento: checkBoxValue ? 'checked' : 'unchecked',
        });
    };

    const handleFinishIdentity = () => {
        showPreLoader();
        loanStatus();
    };

    const handleSuccessVideoSelfie = () => {
        showPreLoader();
        loanIdentification(() => {
            hidePreLoader();
        });
    };

    if (userProfile.identityStatus === START) {
        return (
            <>
                <Header />
                <div className="prospects-content">
                    <div className="identity-verification-views">
                        <VideoScreenContainer type={VIDEO_SELFIE} />
                    </div>
                </div>
            </>
        );
    }

    if (userProfile.identityStatus === COMPLETED) {
        return (
            <SuccessView
                handleFinishIdentity={handleFinishIdentity}
                investmentType={userProfile.investmentType}
                name={userProfile.name}
                onLoad={handleSuccessVideoSelfie}
            />
        );
    }

    return (
        <>
            <FullForm
                icon="identificacion"
                title={formatText('stepsTitles-identityText_ares')}
                subtitle={formatText('stepsTitles-identityTitleCreditCard_ares')}
                cancelAction={handleCancel}
                continueAction={handleContinue}
                formModel="userProfile"
                className="video-selfie-ares__form"
                hideRoadMapNavigation={false}
                continueButtonEnabled
                buttonContinueFakeDisabled={isVideoContinueDisabled()}
                isButtonContinueLoading={userProfile.requestingPermissions}
            >
                <div className={'video-selfie-ares__container'}>
                    <DocumentationRequiredHeader
                        name={userProfile.name}
                        typeDocument={'DNI'}
                        withTabs={false}
                        videoSelected={VIDEO_SELFIE}
                    />
                    <div className="video-selfie-ares__documents-required">
                        <InstructionsList
                            instructions={[
                                {
                                    title: formatText('identity-videoSelfieOtherItemsTitle1Desktop_ares'),
                                    text: formatText('identity-videoSelfieOtherItemsDesc1Desktop_ares'),
                                    hiddenInMobile: true,
                                },
                                {
                                    title: formatText('identity-videoSelfieOtherItemsTitle2Desktop_ares'),
                                    text: formatText('identity-videoSelfieOtherItemsDesc2Desktop_ares'),
                                },
                                {
                                    title: formatText('identity-videoSelfieOtherItemsTitle3Desktop_ares'),
                                    text: formatText('identity-videoSelfieOtherItemsDesc3Desktop_ares'),
                                },
                            ]}
                        />
                        <SafeDataAdvise />
                    </div>
                    {userProfile.grantedPermission === false ? (
                        <ImportantMessageBox
                            isFocus
                            color={'red-highlight-box'}
                            title={'identity-videoCallAllowCameraTitle'}
                            message={getPermissionMessage()}
                        />
                    ) : (
                        <VideoClause onChange={handleVideoClauseChange} isAres />
                    )}
                </div>
            </FullForm>
        </>
    );
};

VideoSelfie.propTypes = {
    identifyVideo: PropTypes.func,
    showModalCancel: PropTypes.func,
    setValidity: PropTypes.func,
    change: PropTypes.func,
    loanStatus: PropTypes.func,
    showPreLoader: PropTypes.func,
    hidePreLoader: PropTypes.func,
    loanIdentification: PropTypes.func,
    options: PropTypes.object,
    userProfile: PropTypes.object,
};
